/* eslint-disable @typescript-eslint/no-empty-function */
import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { TranslateModule } from '@ngx-translate/core'

import { environment } from '@se-po/shared-environments'
import { SeFeApiModule } from 'se-fe-api'
import { SeFeHeaderModule } from 'se-fe-header'
import { SeFePageModule } from 'se-fe-page'

import { SeHouseholdSetupDocsModule } from '../se-household-setup-docs/se-household-setup-docs.module'
import { SeMissingPersonaInfoDocsRoutingModule } from './se-missing-persona-info-docs-routing.module'
import { SeMissingPersonaInfoDocsComponent } from './se-missing-persona-info-docs.component'

@NgModule({
  declarations: [
    SeMissingPersonaInfoDocsComponent
  ],
  imports: [
    CommonModule,
    SeFeApiModule.forRoot({
      domainEnvironments: environment.domainEnvironments,
    }),
    SeMissingPersonaInfoDocsRoutingModule,
    SeFeHeaderModule,
    SeFePageModule,
    SeHouseholdSetupDocsModule,
    TranslateModule.forChild()
  ],
  exports: [SeMissingPersonaInfoDocsComponent]
})
export class SeMissingPersonaInfoDocsModule { }
